import { render, staticRenderFns } from "./RecoRecommendationView.vue?vue&type=template&id=e8b7b7b2&"
import script from "./RecoRecommendationView.vue?vue&type=script&lang=js&"
export * from "./RecoRecommendationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports